import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-78">
      {/* Animated Hero Orbs — vivid, large, continuously moving */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-79">
        <motion.div className="absolute w-[500px] h-[500px] rounded-full mix-blend-screen" style={{
        background: 'radial-gradient(circle, rgba(0,212,255,0.25) 0%, transparent 70%)',
        filter: 'blur(80px)'
      }} animate={{
        x: [0, 120, -80, 60, 0],
        y: [0, -100, 50, -60, 0],
        scale: [1, 1.2, 0.9, 1.1, 1]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'easeInOut'
      }} initial={{
        top: '15%',
        left: '20%'
      }} data-id="element-80" />
        <motion.div className="absolute w-[600px] h-[600px] rounded-full mix-blend-screen" style={{
        background: 'radial-gradient(circle, rgba(0,102,255,0.2) 0%, transparent 70%)',
        filter: 'blur(100px)'
      }} animate={{
        x: [0, -100, 80, -40, 0],
        y: [0, 80, -60, 100, 0],
        scale: [1, 0.85, 1.15, 0.95, 1]
      }} transition={{
        duration: 25,
        repeat: Infinity,
        ease: 'easeInOut'
      }} initial={{
        top: '30%',
        right: '10%'
      }} data-id="element-81" />
        <motion.div className="absolute w-[400px] h-[400px] rounded-full mix-blend-screen" style={{
        background: 'radial-gradient(circle, rgba(0,212,255,0.15) 0%, transparent 70%)',
        filter: 'blur(90px)'
      }} animate={{
        x: [0, 60, -120, 80, 0],
        y: [0, -80, 40, -100, 0],
        scale: [1, 1.1, 0.85, 1.05, 1]
      }} transition={{
        duration: 22,
        repeat: Infinity,
        ease: 'easeInOut'
      }} initial={{
        bottom: '10%',
        left: '40%'
      }} data-id="element-82" />

        {/* Animated floating particles */}
        {Array.from({
        length: 20
      }).map((_, i) => <motion.div key={i} className="absolute w-1 h-1 rounded-full bg-brand-cyan/30" style={{
        left: `${10 + Math.random() * 80}%`,
        top: `${10 + Math.random() * 80}%`
      }} animate={{
        y: [0, -30 - Math.random() * 40, 0],
        x: [0, (Math.random() - 0.5) * 60, 0],
        opacity: [0.2, 0.6, 0.2]
      }} transition={{
        duration: 4 + Math.random() * 6,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: Math.random() * 5
      }} data-id="element-83" />)}

        {/* Grid overlay */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-50" data-id="element-84"></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12 text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-panel border border-brand-cyan/30 text-brand-cyan text-sm font-medium mb-8" data-id="element-86">
          <SparklesIcon className="w-4 h-4" data-id="element-87" />
          <span data-id="element-88">Innovación y Precisión Tecnológica</span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-bold tracking-tight text-white max-w-5xl mx-auto leading-tight mb-6" data-id="element-89">
          Impulsamos tu crecimiento digital con{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-blue" data-id="element-90">
            tecnología inteligente
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-91">
          Transformamos empresas mediante desarrollo web avanzado,
          automatización con IA y estrategias de marketing orientadas a
          resultados medibles.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-92">
          <a href="#contacto" className="w-full sm:w-auto px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-cyan text-white font-semibold text-lg shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.6)] transition-all duration-300 flex items-center justify-center gap-2 group" data-id="element-93">
            Solicitar asesoría
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-94" />
          </a>
          <a href="#servicios" className="w-full sm:w-auto px-8 py-4 rounded-lg glass-panel text-white font-semibold text-lg hover:bg-white/5 transition-all duration-300 flex items-center justify-center" data-id="element-95">
            Conoce más
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-500" data-id="element-96">
        <span className="text-xs uppercase tracking-widest" data-id="element-97">Descubrir</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-gray-500 to-transparent" data-id="element-98"></div>
      </motion.div>
    </section>;
}